<template>
  <k-panel class="ks-floating-menu">
    <template #title>{{instance.title}}</template>
    <template #buttons>
      <k-btn size="m" icon @click="show = !show">
        <k-icon>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</k-icon>
      </k-btn>
    </template>
    <template #default>
      <div v-if="show">
      <k-layout>
        <k-flex c1 class="pa-2">Id</k-flex>
        <k-flex c6 class="pa-2">Input</k-flex>
        <k-flex c6 class="pa-2">Output</k-flex>
      </k-layout>

      <k-layout v-for="item in routing_table" :key="item.out_id" style="border-bottom: 1px solid hsla(0,0%,100%,.12);">
        <k-flex c1 class="pa-2" style="line-height: 60px;">{{parseInt(item.out_id) + 1}}</k-flex>
        <k-flex c6 class="pa-2">
          <k-autocomplete single-line style="height: 60px;" :value="item.in_id" hide-details class="pa-0 ma-0" v-bind:items="inputs" placeholder="Input" item-text="name" item-value="id" label="Input" @change="change_route(item,$event)"></k-autocomplete>
        </k-flex>
        <k-flex c5 class="pa-2" style="line-height: 60px;">{{item.out_label}}</k-flex>
      </k-layout>
      </div>
    </template>
  </k-panel>
</template>

<script>
import InstanceModel from '@/models/instance.js'

export default {
  props: ['id'],
  data() {
    var ch = this.$cloudserver.channel("instances:status:"+this.id);
    return {
      show: false,
      ws_channel: ch
    }
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    stats() {
      return this.ws_channel.data;
    },
    instance () {
			return InstanceModel.instance_by_id(this.id);
		},
    routing_table () {
      var in_labels = _.get(this.stats, "instance.input_labels");
      var out_labels = _.get(this.stats, "instance.output_labels");
      return _.map(_.get(this.stats, "instance.output_routing", {}), (in_id, out_id) => {
        return {
          in_id: in_id,
          in_label: in_labels[in_id],
          out_id: out_id,
          out_label: out_labels[out_id]
        }
      })
    },
    inputs () {
      return _.map(_.get(this.stats, "instance.input_labels"), (inp,id) => { return {name: (parseInt(id)+1) + ": " + inp, id: id} });
    }
  },
  methods: {
    change_route(item, in_id) {
      if(item.in_id != in_id) {
        var self = this;
        InstanceModel.send_command_to_external_device(this.instance, "change-route", {in_id: in_id, out_id: item.out_id}, () => {}, () => {});
      }
    }
  }
}
</script>
